'use client';

import * as React from 'react';
import { ChevronsUpDown, Building2, Check } from 'lucide-react';

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@ui/components/ui/dropdown-menu';
import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '@ui/components/ui/sidebar';
import { useTeam } from '@/hooks/useTeam';
import { useRouter } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { cn } from '@ui/lib/utils';

export function TeamSwitcher() {
  const { teams } = useTeam();
  const { isMobile, toggleSidebar } = useSidebar();
  const router = useRouter();
  const t = useTranslations('Navigation');
  const tTeam = useTranslations('Team');

  const handleViewTeam = () => {
    if (isMobile) toggleSidebar();
    router.push(`/team`);
  };

  if (!teams || teams.length === 0) {
    return null;
  }
  const team = teams[0]!;

  return (
    <SidebarMenuItem>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <SidebarMenuButton className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground">
            <div className="flex aspect-square size-4 items-center justify-center rounded-lg">
              <Building2 className="size-4" />
            </div>
            <div className="grid flex-1 text-left text-sm leading-tight">
              <span className="truncate font-medium">{team.name}</span>
            </div>
            <ChevronsUpDown className="ml-auto" />
          </SidebarMenuButton>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="min-w-56 rounded-lg" side={isMobile ? 'bottom' : 'right'} sideOffset={4} align="end">
          <DropdownMenuLabel className="text-muted-foreground text-xs">{t('teams')}</DropdownMenuLabel>
          {teams.map((t) => (
            <DropdownMenuItem key={t.id} className={cn('gap-2 p-2', t.id === team.id && 'bg-accent')}>
              <div className="flex size-6 items-center justify-center rounded-md border">
                <Building2 className="size-4 shrink-0" />
              </div>
              <div className="flex-1">
                <div className="truncate">{t.name}</div>
                <div className="text-xs text-muted-foreground capitalize">{tTeam(t.role)}</div>
              </div>
              {t.id === team.id && <Check className="ml-auto size-4" />}
            </DropdownMenuItem>
          ))}
          <DropdownMenuSeparator />
          <DropdownMenuItem className="gap-2 p-2" onClick={handleViewTeam}>
            <div className="flex size-6 items-center justify-center rounded-md border bg-transparent">
              <Building2 className="size-4" />
            </div>
            <div className="font-medium">{t('viewTeamSettings')}</div>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </SidebarMenuItem>
  );
}
